// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  height: 48px;
  width: 100px;
  font-weight: 700;
  font-size: 16px;
}

ion-content {
  max-height: 360px;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-game-history-details/popover-game-history-details.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":["ion-button{\r\n    height: 48px;\r\n    width: 100px;\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n}\r\n\r\nion-content {\r\n    max-height: 360px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
